import { Alert, Button } from "reactstrap";
import pluralize from "pluralize";

import AppDrawer, { DrawerSize, Placement } from "./AppDrawer";
import ManageItems from "../ManageItems/ManageItems";
import { LayoutType } from "../../types/GlobalInterfaces";

interface ManageItemsDrawerProps {
  open: boolean;
  onClose: () => void;
  items: Array<any>;
  onEdit?: (item: null | any) => void;
  onDelete?: () => void;
  onReorder?: () => void;
  size?: DrawerSize;
  placement?: Placement;
  backdrop?: boolean | "static";
  title: string;
  itemKey: string;
  description?: string;
  headerDescription?: string;
  savedItemID?: string;
  onSaveAsDefault?: () => void;
  onSaveAsGlobal?: () => void;
  type?: LayoutType;
  errorMessage: string | null;
}

const ManageItemsDrawer = ({
  open,
  onClose,
  items,
  onEdit,
  onDelete,
  onReorder,
  size = "sm",
  placement = "right",
  backdrop = true,
  title,
  itemKey,
  description,
  headerDescription,
  savedItemID,
  onSaveAsDefault,
  onSaveAsGlobal,
  type,
  errorMessage = null,
}: ManageItemsDrawerProps) => {
  return (
    <AppDrawer
      size={size}
      placement={placement}
      backdrop={backdrop}
      open={open}
      onClose={onClose}
      headerTitle={`Manage ${title}`}
      headerDescription={headerDescription}
      headerOptions={
        <>
          {onEdit && (
            <Button size="sm" color="primary" onClick={() => onEdit(null)}>
              Add {pluralize.singular(title || "")}
            </Button>
          )}
        </>
      }
      bodyCSS="pt-3 mx--2 pb-8"
      body={
        <>
          <ManageItems
            itemKey={itemKey}
            items={items}
            onDelete={onDelete}
            onReorder={onReorder}
            onEdit={onEdit}
            title={title}
            description={description}
            savedItemID={savedItemID}
            onSaveAsDefault={onSaveAsDefault}
            onSaveAsGlobal={onSaveAsGlobal}
            type={type}
          />
          {errorMessage && (
            <Alert className="mt-4" color="danger">
              {errorMessage}
            </Alert>
          )}
        </>
      }
    />
  );
};

export default ManageItemsDrawer;
